import { Button } from '@mediahuis/chameleon-react';
import React, { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { RegistrationFlowHeader } from './RegistrationFlowHeader';

type EmailVerificationProps = {
  email: string;
  brandUrlDisplay: string;
  onSubmit: () => void;
};

export const EmailVerification: FC<EmailVerificationProps> = ({
  email,
  brandUrlDisplay,
  onSubmit,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <RegistrationFlowHeader
        title={t('register.finished.title')}
        selector="validateEmailHeader"
        subtitle={
          <Trans
            i18nKey="register.finished.validateYourEmail"
            components={{ strong: <strong /> }}
            values={{ email }}
          />
        }
      />
      <Button
        data-cy="validateEmailButton"
        type="submit"
        width="full"
        appearance="primary"
        onClick={onSubmit}>
        <Trans i18nKey="register.finished.buttonText" values={{ url: brandUrlDisplay }} />
      </Button>
    </>
  );
};
